module.exports = __webpack_public_path__ + "img/volvo.df7e58eb.png";